import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: 'SelectSiteListModal',
  mixins: [JeecgListMixin, GetSiteIdMixin, ModalFormMixin],
  components: {},
  data: function data() {
    return {
      title: '',
      queryParam: {},
      url: {
        queryIotKey: '/site/iot/key'
      },
      validatorRules: {
        vendorInfo: {
          rules: [{
            required: true,
            message: '请输入密钥!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        address: {
          rules: [{
            required: true,
            message: '请输入接口地址!'
          }]
        },
        vendor: {
          rules: [{
            required: true,
            message: '请选择供应商!'
          }]
        }
      },
      form_fields: ['name', 'vendorInfo', 'address', 'vendor'],
      dataSource: [],
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      toggleSearchStatus: false,
      visible: false,
      companyList: [],
      IotKeyList: [],
      showAddModal: false,
      confirmLoading: false
    };
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.title = "新增：密钥";
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      if (record) {
        this.title = "编辑：密钥";
      }

      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('this.model', this.model);
      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //debugger
          //console.log(formData)

          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = '/site/iot/key';
            method = 'post';
          } else {
            httpurl = '/site/iot/key';
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.$emit('getIotKeyList');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    handleChangeVendor: function handleChangeVendor(value) {
      this.model.vendor = value;
    }
  }
};